import { PasswordInput } from "./PasswordInput";
import { PASSWORD_RULES, passwordMeetsPolicy } from "../password-policy";

// Re-exported so a consumer can import the field + the validity predicate
// from one subpath (used to gate submit buttons).
export { passwordMeetsPolicy };

function CheckIcon({ ok }: { ok: boolean }) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {ok ? <path d="M20 6 9 17l-5-5" /> : <circle cx="12" cy="12" r="8" />}
    </svg>
  );
}

/**
 * PasswordInput (reveal + generate) plus a live requirements checklist that
 * turns each rule green as the value satisfies it. `showChecklist` can hide
 * the list once empty/optional. The rules mirror the server policy
 * (see @blog/spa-common/password-policy).
 */
export function PasswordField({
  value,
  onChange,
  onEnter,
  placeholder,
  autoFocus,
  allowGenerate = true,
  showChecklist = true,
}: {
  value: string;
  onChange: (next: string) => void;
  onEnter?: () => void;
  placeholder?: string;
  autoFocus?: boolean;
  allowGenerate?: boolean;
  showChecklist?: boolean;
}) {
  return (
    <div className="space-y-1.5">
      <PasswordInput
        value={value}
        onChange={onChange}
        onEnter={onEnter}
        placeholder={placeholder}
        autoFocus={autoFocus}
        allowGenerate={allowGenerate}
      />
      {showChecklist && value.length > 0 && (
        <ul className="flex flex-wrap gap-x-3 gap-y-0.5 font-mono text-[11px]">
          {PASSWORD_RULES.map((r) => {
            const ok = r.test(value);
            return (
              <li
                key={r.key}
                className={`flex items-center gap-1 ${ok ? "text-success" : "text-mute"}`}
              >
                <CheckIcon ok={ok} />
                {r.label}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
